<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header" v-if="product._id">
        Editing Catalog "{{ product.slotGeneral.name }}"
        <span class="badge" :class="product.status.class" title="Status of catalog">{{ product.status.label }}</span>
      </div>
      <div class="card-body">
        <form v-if="product">
          <div class="alert alert-danger" role="alert" v-show="message">
            {{ message }}
          </div>
          <wizard ref="wizard" :steps="steps" :onSave="saveWizard" :modeWizard="modeWizard">
            <!-- Datails page -->
            <div slot="page-details">
              <div class="row">
                <div class="col-12">
                  <!-- Application name -->
                  <div class="form-group m-3">
                    <label for="name-input">Catalog name</label>
                    <input disabled="disabled" class="form-control" type="text" v-model="product.slotGeneral.name" id="name-input">
                  </div>
                  <!-- Application price -->
                  <div class="form-group m-3">
                    <label for="viewer-check-input" class="mr-4">Catalog price</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="radio" name="appPrice" v-model="product.slotGeneral.price" value="0"> Free Catalog
                      </label>
                    </div>
                  </div>
                  <!-- Certifications -->
                  <div class="form-group m-3">
                    <label for="certifications-check-input" class="mr-4">Format</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" v-model="product.slotGeneral.formats" value="dicom"> Dicom
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="checkbox" v-model="product.slotGeneral.formats" value="json"> JSON
                      </label>
                    </div>
                  </div>
                  <!-- Applications/Clinical area/Modality -->
                  <div class="form-group m-3">
                    <div class="row">
                      <div class="col-md-12">
                        <label for="description-textarea">
                          <h4>Categories</h4>
                        </label>
                      </div>
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">Modality</label>
                        <div class="form-check" v-bind:key="mod" v-for="mod in modalities">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="mod" v-model="product.slotDetails.categories"> {{ mod }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">Body Region</label>
                        <div class="form-check" v-bind:key="bodyRegion" v-for="bodyRegion in bodyRegions">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="bodyRegion" v-model="product.slotDetails.categories"> {{ bodyRegion | capita }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">Organ</label>
                        <div class="form-check" v-bind:key="or" v-for="or in organs">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="or" v-model="product.slotDetails.categories"> {{ or }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">pathology</label>
                        <div class="form-check" v-bind:key="pathology" v-for="pathology in pathologies">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="pathology" v-model="product.slotDetails.categories"> {{ pathology }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">Type</label>
                        <div class="form-check" v-bind:key="tp" v-for="tp in types">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="tp" v-model="product.slotDetails.categories"> {{ tp }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">Orientation</label>
                        <div class="form-check" v-bind:key="ori" v-for="ori in orientation">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="ori" v-model="product.slotDetails.categories"> {{ ori }}
                          </label>
                        </div>
                      </div>
                      <!-- Device -->
                      <div class="form-group col-lg-3 m-b-15">
                        <label class="col-lg-3 col-form-label">Device</label>
                        <div class="col-lg-9">
                          <div >
                          <div class="form-check mb-1">
                            <input id="GE" disabled="disabled" class="form-check-input" type="checkbox"
                              v-model="product.slotGeneral.device" value="GE">
                            <label for="GE" class="fs-13px fw-bold">GE</label>
                          </div>
                        </div>
                        <div >
                          <div class="form-check mb-1">
                            <input id="philips" disabled="disabled" class="form-check-input disabled" type="checkbox"
                              v-model="product.slotGeneral.device" value="philips">
                            <label for="philips" class="fs-13px fw-bold">Philips</label>
                          </div>
                        </div>
                        <div >
                          <div class="form-check mb-1">
                            <input id="siemens" disabled="disabled" class="form-check-input" type="checkbox"
                              v-model="product.slotGeneral.device" value="siemens">
                            <label for="siemens" class="fs-13px fw-bold">Siemens</label>
                          </div>
                        </div>
                        <div>
                          <div class="form-check mb-1">
                            <input id="canon"disabled="disabled"  class="form-check-input" type="checkbox"
                              v-model="product.slotGeneral.device" value="canon">
                            <label for="canon" class="fs-13px fw-bold">Canon</label>
                          </div>
                        </div>
                        </div>
                      </div>
                      
                      
                      <div class="col-md-3">
                        <label class="fw-bold mb-2">Number of studies
                          </label>
                          <p v-html="product.slotDetails.patient"></p>
                      </div>

                      <div class="col-md-5">
                        <label class="fw-bold mb-2">Protocol CT</label>
                        <div class="form-check" v-bind:key="protct" v-for="protct in protocolCT">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="protct" v-model="product.slotDetails.categories"> {{ protct }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-3 ">
                        <label class="fw-bold mb-2">Protocol MRI</label>
                        <div class="form-check" v-bind:key="protmri" v-for="protmri in protocolMri">
                          <label class="form-check-label">
                            <input disabled="disabled" class="form-check-input" type="checkbox" :value="protmri" v-model="product.slotDetails.categories"> {{ protmri }}
                          </label>
                        </div>
                      </div>
                    <div class="col-lg-3">
                      <label for="gender-input" class="col-lg-3 col-form-label">Gender</label>
                      <div class="radio m-1 pe-2">
                        <input disabled="disabled" id="radio_m" class="form-check-input" type="radio" name="gender" value="M"
                          v-model="product.slotGeneral.gender">
                        <label for="radio_m">M</label>
                      </div>
                      <div class="radio m-1 ">
                        <input disabled="disabled" id="radio_f" class="form-check-input" type="radio" name="gender" value="F"
                          v-model="product.slotGeneral.gender">
                        <label for="radio_f">F</label>
                      </div>
                      <div class="radio m-1">
                        <input disabled="disabled" id="radio_all" class="form-check-input" type="radio" name="gender" value="All inclusive"
                          v-model="product.slotGeneral.gender">
                        <label for="radio_all">All inclusive</label>
                      </div>
                    </div>    
                  <!-- Country -->
                  <div class="form-group ">
                    <h6><label for="description-textarea">Country</label></h6>
                    <input disabled="disabled" class="form-control" type="text" v-model="product.slotDetails.country" id="name-input">
                  </div>
                  <!-- age -->
                  <div class="form-group">
                    <h6><label for="description-textarea">Age</label></h6>
                    <input disabled="disabled" class="form-control" type="text" v-model="product.slotDetails.age" id="name-input">
                  </div>
                      <!--Outcomes-->
                  <div class="form-group row m-b-15">
                    <label for="outcomes-input" class="col-lg-3 col-form-label">Outcomes</label>
                    <div class="col-lg-7 d-flex align-items-center">
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_y-outcomes" class="form-check-input" type="radio" name="outcomes" value="yes"
                          v-model="product.slotGeneral.outcomes">
                        <label for="radio_y-outcomes" class="form-check-label">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_n-outcomes" class="form-check-input" type="radio" name="outcomes" value="no"
                          v-model="product.slotGeneral.outcomes">
                        <label for="radio_n-outcomes" class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>

                  <!-- Multi Device -->
                  <div class="form-group row m-b-15">
                    <label for="multi-device-input" class="col-lg-3 col-form-label">Multi Device?</label>
                    <div class="col-lg-7 d-flex align-items-center">
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_y-device" class="form-check-input" type="radio" name="multiDevice" value="yes"
                          v-model="product.slotGeneral.multiDevice">
                        <label for="radio_y-device" class="form-check-label">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_n-device" class="form-check-input" type="radio" name="multiDevice" value="no"
                          v-model="product.slotGeneral.multiDevice">
                        <label for="radio_n-device" class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>

                  <!-- Multi Centric -->
                  <div class="form-group row m-b-15">
                    <label for="multi-centric-input" class="col-lg-3 col-form-label">Multi Centric?</label>
                    <div class="col-lg-7 d-flex align-items-center">
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_y-centric" class="form-check-input" type="radio" name="multiCentric" value="yes"
                          v-model="product.slotGeneral.multiCentric">
                        <label for="radio_y-centric" class="form-check-label">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_n-centric" class="form-check-input" type="radio" name="multiCentric" value="no"
                          v-model="product.slotGeneral.multiCentric">
                        <label for="radio_n-centric" class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>

                  <!-- Annotated -->
                  <div class="form-group row m-b-15">
                    <label for="annotated-input" class="col-lg-3 col-form-label">Annotated?</label>
                    <div class="col-lg-7 d-flex align-items-center">
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_y-annotated" class="form-check-input" type="radio" name="annotated" value="yes"
                          v-model="product.slotGeneral.annotated">
                        <label for="radio_y-annotated" class="form-check-label">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_n-annotated" class="form-check-input" type="radio" name="annotated" value="no"
                          v-model="product.slotGeneral.annotated">
                        <label for="radio_n-annotated" class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>

                  <!-- Follow Up -->
                  <div class="form-group row m-b-15">
                    <label for="follow-up-input" class="col-lg-3 col-form-label">Follow Up?</label>
                    <div class="col-lg-7 d-flex align-items-center">
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_y-follow" class="form-check-input" type="radio" name="followUp" value="yes"
                          v-model="product.slotGeneral.followUp">
                        <label for="radio_y-follow" class="form-check-label">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_n-follow" class="form-check-input" type="radio" name="followUp" value="no"
                          v-model="product.slotGeneral.followUp">
                        <label for="radio_n-follow" class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>

                  <!-- Contrast Enhanced -->
                  <div class="form-group row m-b-15">
                    <label for="contrast-enhanced-input" class="col-lg-3 col-form-label">Contrast Enhanced?</label>
                    <div class="col-lg-7 d-flex align-items-center">
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_y-contrast" class="form-check-input" type="radio" name="contrastEnhanced" value="yes"
                          v-model="product.slotGeneral.contrastEnhanced">
                        <label for="radio_y-contrast" class="form-check-label">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled="disabled" id="radio_n-contrast" class="form-check-input" type="radio" name="contrastEnhanced" value="no"
                          v-model="product.slotGeneral.contrastEnhanced">
                        <label for="radio_n-contrast" class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>

                    </div>
                  </div>
                    <!-- Overview -->
                    <div class="form-group m-3">
                    <label for="overview-textarea"><h4>Overview</h4></label>
                    <p>{{ product.slotDetails.overview }}</p>
                  </div>
                  <!-- Description -->
                  <div class="form-group m-3">
                    <label for="description-textarea">
                      <h4>Product description</h4>
                    </label>
                    <p v-html="product.slotDetails.description"></p>
                  </div>
                  <!-- SYSTEM REQUIREMENT -->
                  <div class="form-group m-3">
                    <label for="systemrequirement-textarea">
                      <h4>System requirement</h4>
                    </label>
                    <p v-html="product.slotDetails.systemRequirement"></p>
                  </div>
                  <!-- LAST UPDATES -->
                  <div class="form-group m-3">
                    <label for="lastupdates-textarea">
                      <h4>Last updates</h4>
                    </label>
                    <p v-html="product.slotDetails.lastUpdates"></p>
                  </div>
                  <!-- ADD VIDEO -->
                  <!--<div class="form-group m-3">
                      <label for="video-url-input">Youtube video</label>
                      <input disabled="disabled" class="form-control" type="url" v-model="product.slotDetails.video.src">
                  </div> -->
                  <div class="form-group m-3">
                    <label for="publications-textarea">
                      <h4>Publications</h4>
                      <p v-if="product.slotPublications.publications && !product.slotPublications.publications">No publications</p>
                      <ul>
                        <li :key="pub.link" v-for="pub in product.slotPublications.publications">
                          <a :href="pub.link" target="_new"><strong>{{ pub.title }}</strong></a>
                        </li>
                      </ul>
                    </label>
                  </div>
                  <!-- ADD VIDEO -->
                  <div class="form-group m-3">
                    <label for="video-textarea">
                    <h4>Youtube video</h4>
                    <p>
                      <iframe v-for="(video, videoIndex) in product.slotDetails.videos" :key="videoIndex" width="300" height="200" :src="video.src" class="mr-2"></iframe>
                    </p>
                    </label>
                  </div>
                  <!-- ADD USERGUIDE -->
                  <div class="form-group m-3">
                    <label for="logo-file-input">Userguide</label>
                    <!--"product.slotDetails.userguide"></upload-file-input-->
                  </div>
                  <!-- Is App already distributed? -->
                  <div class="form-group m-3">
                    <label for="link-external-distributed-input" class="mr-4">Is your catalog already distributed online?</label>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="radio" name="externaldistributed" v-model="product.slotGeneral.externalLinkDist"> Yes
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input disabled="disabled" class="form-check-input" type="radio" name="externaldistributed" v-model="product.slotGeneral.externalLinkDist" > No
                      </label>
                    </div>
                    <div class="form-input">
                      <input disabled="disabled" class="form-control" id="is-already-distributed-input" placeholder="" type="url" v-model="product.slotGeneral.externalLinkDist">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Digital content page -->
            <div slot="page-digit-content">
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-warning" v-if="!product.slotGeneral.app.name">No file uploaded for this catalog</div>
                  <table class="table" v-if="product.slotGeneral.app.name">
                    <thead>
                      <tr>
                        <th>File Name</th>
                        <th>Title</th>
                        <th>Size</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">{{ product.slotGeneral.app.name }}</th>
                        <td>{{ product.slotGeneral.app.name }}</td>
                        <td>{{ displaySize }}</td>
                        <td><a :href="`https://api.womia.io/media/${product.slotGeneral.app.slug}`" class="link-download">Download</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Images page -->
            <div slot="page-images">
              <div class="row">
                <div class="col-12">
                  <!-- Logo -->
                  <div class="form-group">
                    <label for="logo-file-input">Catalog logo</label>
                    <div class="d-flex flex-row flex-wrap">
                      <img class="d-block logo-app" :src="product.slotImages.logo.slug | media"></img>
                    </div>
                  </div>
                  <!-- Screenshots -->
                  <div class="form-group">
                    <label for="screenshots-file-input">Screenshots</label>
                    <div class="d-flex flex-row flex-wrap">
                      <div class="screenshots mr-2" v-for="(image, imageIndex) in product.slotImages.screenshots" :key="image.slug">
                        <img class="d-block" :src="image.slug | media" :style="{ width: '100px', height: '70px' }"></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Notification page -->
            <div slot="page-notifications" id="page-notifications">
              <div class="row">
                <div class="col-md-10 py-3">
                  <div class="form-group row">
                    <label for="approvalSelect" class="col-sm-3 col-form-label">Approval</label>
                    <div class="col-sm-9 mb-2">
                      <select class="form-control" id="approvalSelect" v-model="product.newStatus">
                        <option value="approved">Approved</option>
                        <option value="pending">Waiting for approval</option>
                        <option value="declined">Declined</option>
                        <option value="closed">Closed</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-3">Kindly check if you need to send mail to user about this product update</div>
                    <div class="col-sm-9 mb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="inputRecipient" class="col-sm-3 col-form-label">Recipient</label>
                    <div class="col-sm-9">
                      <input type="email" class="form-control" id="inputRecipient" placeholder="Email">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="notifToUser" class="col-sm-3 col-form-label">Subject</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" id="notifToUser" placeholder="Notification to user">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="notifToUser" class="col-sm-3 col-form-label">Message</label>
                    <div class="col-sm-9 mt-2">
                      <vue-editor id="message" :editorToolbar="customToolbar"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </wizard>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import Wizard from '@/components/Wizard'
import Dialog from '@/components/Dialog'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'EditProductAdmin',
  components: { 'vue-editor': VueEditor, 'wizard': Wizard, 'modal': Dialog },
  computed: {
    displaySize() {
      const sizeBin = this.product.slotGeneral.technicalDetails.size
      const divid = (sizeBin > 1000 * 1000) ? { nb: 1000 * 1000, unit: ' MB' } : { nb: 1000, unit: ' KB' }
      return Math.round(this.product.slotGeneral.technicalDetails.size / divid.nb * Math.pow(10, 1)) / Math.pow(10, 1) + divid.unit
    }
  },
  data() {
    return {
      message: null,
      showModal: false,
      modeWizard: 'tab',
      steps: [{
        label: 'Details',
        slot: 'page-details'
      },
      {
        label: 'Digital content',
        slot: 'page-digit-content'
      },
      {
        label: 'Images',
        slot: 'page-images'
      },
      {
        label: 'Notifications',
        slot: 'page-notifications'
      }],
      publication: {},
      product: {
        slotGeneral: {
          technicalDetails: {}
        },
        slotImages: {
          logo: {}
        },
        slotDetails: {
          video: {}
        },
        slotPublications: {}
      },
     
      modalities: ["mri", "xray", "ct", "eeg", "ecg"],
      organs: ["lung", "heart", "liver", "arteries", "trachea", "spine", "pancreas", "spleen", "kidneys", "intestines", "bone", "breast", "teeth", "other"],
      bodyRegions: ["chest", "abdominal", "pelvic", "head", "cervical", "whole body", "chest abdominal", "chest abdominal pelvic", "cervical chest abdominal pelvic", "chest abdominal pelvic head"],
      pathologies: ["healthy", "covid", "nodule", "masse", "fibrosis", "emphysma", "pulmonary interstitial disease", "dilated heart", "thormbus", "atheroma", "dissection", "aneurysm", "pulmonary disease", "arterial disease", "heart disease"],
      orientation: ["axial", "coronal", "sagittal", "short-axis", "long-axis-2-cavities", "long-axis-3-cavities", "long-axis-4-cavities", "multiplanar", "multiplanar-radial", "multiplanar-short-axis"],
      types: ["2D", "2D+T", "2D+t", "3D", "3D+T", "3D+t", "none"],
      age: ["20-30", "30-40", "40-50", "50-60", "60-70", "70-80"],
      protocolMri: ["flow-2D", "flow-3D", "cine SSFP", "cardiac-function", "anatomy", "perfusion", "enhancement", "tagging", "angiography", "t1-mapping", "t2-mapping", "t2* mapping", "dixon"],
      protocolCT: ["chest-", "abdominal-", "pelvic-", "cerebral", "cervical-", "whole-body", "chest-abdominal", "chest-abdominal-pelvic", "cervical-chest-abdominal-pelvic", "chest-abdominal-pelvic-cerebral", "abdominal-pelvic", "cervical spine",
           "Aortic-Angiography", "thoracic-angiography", "supra-aortic-trunks-angiography", "lower-extremity-angiography", "cerebral-angiography", "abdominal-angiography", "thoracic-spine", "lumbar-spine", "coronary"],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ['clean']
      ]
    }
  },
  mixins: [validationMixin],
  validations: {
    product: {
      slotGeneral: {},
      slotImages: {},
      slotDetails: {}
    }
  },
  created: function() {
    if (this.$route.params.slug) {
      this.fetchData()
    }
  },
  methods: {
    hideMessages() {
      this.message = null
    },
    showErrorMessage(message) {
      this.message = message
    },
    fetchData() {
      this.$http.get(`product/admin/${this.$route.params.slug}`).then(
        response => {
          this.populateProduct(response.data)
        },
        err => {
          // error callback
          console.log(err)
        }
      )
    },
    populateProduct(product) {
      /* set general params */
      this.product._id = product._id
      this.product.slugRef = product.slugRef
      const viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'badge-warning rouded-pill' },
        'pending': { 'label': 'Waiting for approval', 'class': 'badge-info rouded-pill' },
        'declined': { 'label': 'Declined', 'class': 'badge-danger rouded-pill' },
        'approved': { 'label': 'Approved', 'class': 'badge-success rouded-pill' },
        'closed': { 'label': 'Closed', 'class': 'badge-secondary rouded-pill' }
      }
      this.product.status = viewStatus[product.status]
      this.product.newStatus = product.status
      this.product.slotGeneral = {
        name: product.name,
        app: product.app,
        technicalDetails: product.technicalDetails || {},
        certifications: product.certifications,
        formats: product.formats,
        externalLinkDist: product.externalLinkDist,
        price: product.price,
        device:product.device,
        gender: product.gender,
        contrastEnhanced: product.contrastEnhanced,
        multiCentric: product.multiCentric,
        multiDevice: product.multiDevice,
        followUp: product.followUp,
        annotated: product.annotated,
        outcomes: product.outcomes,
      }
      /* set images params */
      this.product.slotImages = {
        logo: product.logo,
        screenshots: product.screenshots
      }
      /* set details params */
      this.product.slotDetails = {
        overview: product.overview,
        categories: product.categories,
        description: product.description,
        country: product.country,
        age: product.age,
        patient: product.patient,
        systemRequirement: product.systemRequirement,
        lastUpdates: product.lastUpdates,
        videos: product.videos || [],
        userGuide: product.userGuide
      }
      /* set publications params */
      this.product.slotPublications = {
        publications: product.publications || []
      }
    },
    action(promise) {
      this.hideMessages()

      if (!this.$v.$invalid) {
        promise.then(
          response => {
            const redirectToAppsList = {
              path: '/admin/product'
            }
            this.$router.push(redirectToAppsList)
          },
          err => {
            // error callback
            this.showErrorMessage('Sorry but an error occurred when submitting form')
            console.log(err)
          }
        )
      } else {
        this.showErrorMessage('Please make sure all required fields are filled out correctly')
      }
    },
    updateNewStatus() {
      // TODO use popup for confirmation
      this.action(
        this.$http.post(`product/admin/${this.$route.params.slug}`, { '_id': this.product._id, 'status': this.product.newStatus, 'slugRef': this.product.slugRef })
      )
    },
    saveWizard(currentPage) {
      this.updateNewStatus()
      return true
    }
  }
}
</script>
<style>
  .app-file .box {
    display: inline-block;
    padding: 4px;
    min-width: 100px;
  }
  .badge-success{
    background-color: rgb(66, 184, 66);
    color: white;
  }
  .badge-danger{
    background-color: rgb(250, 243, 43);
    color: rgb(194, 188, 188);
  }
  .badge-warning{
    background-color: rgb(222, 103, 39);
    color: white;
  }
  .badge-info{
    background-color: rgb(49, 55, 181);
    color: white;
  }
  .badge-secondary{
    background-color: rgb(69, 70, 72);
    color: white;
  }
</style>
<style scoped>
  .form-check-input {
    top: -3px;
  }
  #page-notifications .form-check-input {
    margin: 0;
  }
  .form-group > label {
    font-size: 14px;
  }
  .logo-app {
    width: 200px;
    height: 100%;
    border: 1px solid #d8d4d4;
    box-shadow: 1px 2px #c3b3b3;
  }
</style>




// WEBPACK FOOTER //
// src/admin/views/product/EditApp.vue